<template>
  <v-app>
    <v-content>
      
    
    <v-container wrap>
      <v-row class="mt-3 pt-2">
        <v-col cols="12" sm="12" md="8">
          <video class="pa-1 secondary" style="width: 100%; outline: none;" :src="url" controls></video>  
        
        </v-col> 
        <v-col >
            <v-list style="height: 350px;" class="overflow-y-auto">
              <v-list-item
                v-for="e in ep"
                :key="e.id"
                :to="'/episodes' + '/' + e.numero"
                >Capitulo {{ e.numero }} - {{ e.titulo }}</v-list-item
              >
            </v-list>
          
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          
          <v-card>
            <v-card-text>
              <div class="display-1 white--text text-left">Descripcion del Episodio</div>
          <br>
          <p class="white--text text-left">
            
            {{ description }}
            
          </p>
            </v-card-text>
          </v-card>
        </v-col>
                  

      </v-row>
      <vue-disqus shortname="megaloboxlatino"></vue-disqus>   
    </v-container>
    <v-footer class="mx-auto">
      <p class="mx-auto">Megalobox 2019</p>
    </v-footer>
    </v-content>
  </v-app>
</template>

<script>
import axios from 'axios'
import JSSoup from 'jssoup'; 

export default {
  name: "viewep",

  data() {
    return {
      ep: [],
      url: '',
      description: '',
      fb: ''
    };
  },

  created(){
        this.fb = `<div class="fb-comments" data-colorscheme="dark" :data-href="'https://megalobox.web.app/'+this.$route.params.numero" data-numposts="20" style="width: 100%"></div>`

  },

  beforeCreate(){
    this.fb= ''
  },


  async mounted() {
    this.ep = await this.$store.dispatch("bindEpisodes")
    this.description = this.ep[this.$route.params.numero].descripcion


  },

  async updated(){
    await axios.get('https://cors-anywhere.herokuapp.com/'+this.ep[this.$route.params.numero - 1].link)
    .then(res => {
      let soup = new JSSoup(res.data)
      // this.url = soup
      this.url = soup.findAll('c-wiz')[5].attrs['data-url']+'=m22'

      

  })
    
  },

  methods: {
    async getLink() {
      return await this.ep;
    }
  }
};
</script>

<style></style>
